import React ,{useEffect, useState, useContext} from 'react'
import './EnvsPage.scss';
import { Redirect } from "react-router-dom";
import Cookies from 'universal-cookie';
import { css } from "@emotion/react";
import Modal from "react-modal";
import Env_modal from '../Env_modal/Env_modal';
import socket from '../../socket/socket'
import { captureException } from '@sentry/browser';
import Looks3Icon from '@mui/icons-material/Looks3';
import LooksOneIcon from '@mui/icons-material/LooksOne';
import LooksTwoIcon from '@mui/icons-material/LooksTwo';
import Looks4Icon from '@mui/icons-material/Looks4';
import Looks5Icon from '@mui/icons-material/Looks5';
import Looks6Icon from '@mui/icons-material/Looks6';
import ErrorIcon from '@mui/icons-material/Error';
import Moment, { now } from 'moment'
import Button from '../Button/Button';
import AddIcon from '@mui/icons-material/Add';
import CreateEnv from '../CreateEnv/CreateEnv'
import PermissionsGate from '../PermissionsGate/PermissionsGate'
import {SCOPES} from '../PermissionsGate/permissionMaps'
const cookies = new Cookies();


const numbers_map={
  0: <a/>,
  1:<LooksOneIcon sx={{ 
    color: "firebrick", 
    "font-size": "1.2rem"
  }}/>,
  2:<LooksTwoIcon sx={{ 
    color: "firebrick", 
    "font-size": "1.2rem"
  }}/>,
  3:<Looks3Icon sx={{ 
    color: "firebrick", 
    "font-size": "1.2rem"
  }}/>,
  4:<Looks4Icon sx={{ 
    color: "firebrick", 
    "font-size": "1.2rem"
  }}/>,
  5:<Looks5Icon sx={{ 
    color: "firebrick", 
    "font-size": "1.2rem"
  }}/>,
  6:<Looks6Icon sx={{ 
    color: "firebrick", 
    "font-size": "1.2rem"
  }}/>,
  30:<ErrorIcon sx={{ 
    color: "firebrick", 
    "border-radius": "5px",
    "font-size": "1rem"
  }}/>,
}
Modal.setAppElement("#root");

export default function EnvsPage() {

  const [activeIndex, setActiveIndex] = useState(-1);

  useEffect(async () => {
    socket.on('env_created', async function(inputs) {
      if(cookies.get("login")==inputs[0]){
        setClicked(false);
        var options = {
          'method': 'POST',
          'headers': {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
        "login": cookies.get("login")
        })
      };
      await fetch(process.env.REACT_APP_INFRA_SERVICE_URL+"/github/get_prev_env/" , options).then(response=>response.json())
      .then(async data=>{ 
        try{
          set_prev_envs(data);
          if (data.err){
            const event_id = captureException(data.err);
            console.log('error logged', { event_id }); 
          }
        }
        catch(error) {
          set_prev_envs([])
          const event_id = captureException(error);
          console.log('error logged', { event_id });
        }
            
      });  
      }
    });
    socket.on('create_new_env.sh', function(inputs) {
      if(cookies.get("login")==inputs[0]){
        setClicked(false);
      }
    });

  
    socket.on('creating_env', function(inputs) {
      if(cookies.get("login")==inputs[0]){
        setClicked(true)
      }
    });

  },[])
  

  const[clicked, setClicked] = useState(false);
  const[prev_envs,set_prev_envs]=useState([]);
  const[frontend_branches,set_frontend_branches]=useState([]);
  const[backend_branches,set_backend_branches]=useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [env,setEnv] = useState();
  const[all_envs,set_all_envs] = useState([])
  const [users, set_users] = useState([])
  const front_default_props = {
      options: frontend_branches,
      getOptionLabel: (option) => option,
  };
    
  const back_default_props = {
    options: backend_branches,
    getOptionLabel: (option) => option,
  };

  const all_envs_default_props = {
    options: all_envs,  
    getOptionLabel: (option) => option,
  };

  const override = css`
  display: block;
  margin: 30 auto;
  border-color: red;
`;

useEffect(() => {
  (async () => {
      var options = {
          'method': 'POST',
          'headers': {
              'Content-Type': 'application/json'
          },
          body: JSON.stringify({
              "code": cookies.get("code"),
              "repo": "backend"
          })
      };
      
      try {
          const backendResponse = await fetch(process.env.REACT_APP_INFRA_SERVICE_URL+"/github/branches/" , options)
          const backData = await backendResponse.json();
          if (backData.err){
              const event_id = captureException(backData.err);
              cookies.remove("code");
              return <Redirect to="/login" />;      
          } else {
              set_backend_branches(backData);
          }

          // Fetch for frontend
          options.body = JSON.stringify({
              "code": cookies.get("code"),
              "repo": "frontend"
          })

          const frontendResponse = await fetch(process.env.REACT_APP_INFRA_SERVICE_URL+"/github/branches/", options);
          const frontData = await frontendResponse.json();

          if (frontData.err) {
              const event_id = captureException(frontData.err);
              console.log('error logged', { event_id }); 
              cookies.remove("code");
              <Redirect to="/login" />
          } else {
              set_frontend_branches(frontData);
          }

      } catch (error) {
          console.error("Error fetching data: ", error);
          // Handle error e.g. redirect to error page
      }
  })();
}, []);

  useEffect(async () => {
    
    var options = {
      'method': 'POST',
      'headers': {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
    "login": cookies.get("login")
    })
  };
  await fetch(process.env.REACT_APP_INFRA_SERVICE_URL+"/github/get_prev_env/" , options).then(response=>response.json())
  .then(async data=>{ 
    try{
      if (data.err){
        const event_id = captureException(data.err);
        console.log('error logged', { event_id }); 
      }
      set_prev_envs(data);
    }
    catch(error) {
      const event_id = captureException(error);
      console.log('error logged', { event_id });
      set_prev_envs([])
    }
        
  }); 
},[])

useEffect(async () => {
    
  var options = {
    'method': 'POST',
    'headers': {
    'Content-Type': 'application/json'
  },
  body: JSON.stringify({
  })
};
await fetch(process.env.REACT_APP_INFRA_SERVICE_URL+"/github/get_all_envs/" , options).then(response=>response.json())
.then(async data=>{ 
  try{
    if (data.err){
      const event_id = captureException(data.err);
      console.log('error logged', { event_id }); 
    }
    set_all_envs(data);
  }
  catch(error) {
    const event_id = captureException(error);
    console.log('error logged', { event_id });
    set_all_envs([])
  }
      
}); 
},[])

  useEffect(async () => {
    var options = {
      'method': 'POST',
      'headers': {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
    "code": cookies.get("code")
    })
  };
  await fetch(process.env.REACT_APP_INFRA_SERVICE_URL+"/github/get_users/"  , options).then(response=>response.json())
  .then(async data=>{ 
    try{
      if (data.err){
        const event_id = captureException(data.err);
        console.log('error logged', { event_id }); 
      }
      set_users(data);
    }
    catch(error) {
      const event_id = captureException(error);
      console.log('error logged', { event_id });
    }
        
  });  

},[])

  useEffect(async () => {
    
        var options = {
          'method': 'POST',
          'headers': {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          "code": cookies.get("code"),
          "login": cookies.get("login"),
        })

    };
    fetch(process.env.REACT_APP_INFRA_SERVICE_URL+"/github/get_action_status/" , options).then(response=>response.json())
    .then(async data=>{ 
      if (data.err){
        const event_id = captureException(data.err);
        console.log('error logged', { event_id }); 
      }
      setClicked(data.creating_env)  
    });        
  },[] );

  function openModal(e) {
    setEnv(e)
    setIsOpen(true);
    setActiveIndex(e.env_name)
  }


  if(cookies.get("code")==undefined) {
    return <Redirect to="/login" />;
  }


  function get_days_left(env){

    var dates=[new Date(env.created_at||now()),new Date(env.frontend_last_update||now()),new Date(env.backend_last_update||now())]
    var maxDate=new Date(Math.max.apply(null,dates));
    const res=Moment(maxDate).add(7,"days");
    let timeDifference = new Date().getTime() - new Date(res).getTime();
    let dayMilliSeconds = 1000 * 60 * 60 * 24;
    let totalDays = Math.abs(timeDifference / dayMilliSeconds);
    totalDays = Math.round(totalDays);
    if(totalDays<1)
      return 0;
    return totalDays;
  }
  return (
 
    <PermissionsGate scopes={[SCOPES.canEdit]} >
  <div className="split right">

    <div id="container">
      <div id="col1">

      <div id="prev_envs">
      
                <div className="prev_envs_title">
                Previous environment
                  <Button text="Create new" style={{"width": "9em" , "fontWeight": "600" , background: activeIndex==-1 &&  "#E6F1FF" , border: activeIndex==-1 &&  "1px solid #3E45EF"}} startIcon={<AddIcon/>} onClick={()=>{setIsOpen(false); setActiveIndex(-1)}}/>
                </div>
      
              {prev_envs?.map((env) =>
              
                <div key={env.env_name} className="env_list" onClick={()=>openModal(env)} style={{ color: "#3b4b52" , background: env.env_name==activeIndex &&  "#E6F1FF" , border: env.env_name==activeIndex &&  "1px solid #3E45EF"}}>
                  <div>
                    {env.env_name} 
                    </div>
                    {env.temp_env && <div>
                      Left: {get_days_left(env)} days
                      </div>
                    }
                </div>
            )}
            </div> 
            <div > 

                </div>
      </div>
      {activeIndex== -1 ? (
        <CreateEnv all_envs={all_envs} front_default_props={front_default_props} back_default_props={back_default_props} all_envs_default_props={all_envs_default_props} clicked={clicked} setClicked={setClicked}/>

      ):(
        <Env_modal env={env} setEnv={setEnv} setIsOpen={setIsOpen} set_prev_envs={set_prev_envs} prev_envs={prev_envs} front_default_props={front_default_props} back_default_props={back_default_props} users={users} setActiveIndex={setActiveIndex} id="col2"/>

      )}

       </div>

    </div>
    </PermissionsGate>
    
        
  );
}